// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lyk3","colBig":"styles_colBig__36ro2","colSmall":"styles_colSmall___m-sM"};